import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

/** Add-law-firm dialog shared by bond creation and retrieval flows. */
export default function BondQuickAddLawFirmDialog({
  open,
  onClose,
  onSubmit,
  lawFirm,
  setLawFirm,
  disabled = false,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Add New Law Firm</DialogTitle>
      <DialogContent>
        <TextField
          disabled={disabled}
          label="Law Firm Name"
          name="name"
          value={lawFirm.name}
          onChange={(e) => setLawFirm({ ...lawFirm, name: e.target.value })}
          fullWidth
          required
          margin="normal"
        />
        <TextField
          disabled={disabled}
          label="Phone"
          name="phone"
          value={lawFirm.phone}
          onChange={(e) => setLawFirm({ ...lawFirm, phone: e.target.value })}
          fullWidth
          required
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={onSubmit} color="primary" disabled={disabled}>
          Add Law Firm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
